// extracted by mini-css-extract-plugin
export var contained = "VEsrvy66eE0x8ld51aMz";
export var focusVisible = "YtNBnJ8_RGK7JDWAKFRp";
export var large = "RPqs3GWuvL8sZTixyoos";
export var root = "bpbgkHfJbR1k_KV0VvPR";
export var small = "TNCNcYNDH5Tb3n0HJ9qg";